import React from 'react';
import PropTypes from 'prop-types';
import { Table, Message, Header } from 'semantic-ui-react';
import IneligiblePurchasesListRow from './ListRow';

const IneligiblePurchasesList = ({ guaranteePurchases }) => {
  const listRow = IneligiblePurchasesListRow();

  if (!guaranteePurchases || guaranteePurchases.length === 0) {
    return (
      <div>
        <Header>Ineligible Purchases</Header>
        <Message info content='No data found.' />
      </div>
    );
  }

  const headerRow = (
    <Table.Row>
      <Table.HeaderCell>VIN</Table.HeaderCell>
      <Table.HeaderCell>External ID</Table.HeaderCell>
      <Table.HeaderCell>Guaranteed At</Table.HeaderCell>
      <Table.HeaderCell>Dealer Number</Table.HeaderCell>
      <Table.HeaderCell>Auction (name/sale/lane/run)</Table.HeaderCell>
      <Table.HeaderCell>Vehicle</Table.HeaderCell>
      <Table.HeaderCell>Odometer (M)</Table.HeaderCell>
      <Table.HeaderCell>Vehicle Purchase Price</Table.HeaderCell>
      <Table.HeaderCell>Status</Table.HeaderCell>
      <Table.HeaderCell>Product</Table.HeaderCell>
      <Table.HeaderCell>Price</Table.HeaderCell>
      <Table.HeaderCell>Partner</Table.HeaderCell>
      <Table.HeaderCell>Payment Kind</Table.HeaderCell>
    </Table.Row>
  );

  return (
    <div>
      <Header>Ineligible Purchases</Header>
      <div>
        <Table
          celled
          selectable
          padded
          renderBodyRow={listRow}
          tableData={guaranteePurchases}
          headerRow={headerRow}
          size='small'
          compact='very'
          style={{ fontSize: '90%' }}
          striped
        />
      </div>
    </div>
  );
};

IneligiblePurchasesList.propTypes = {
  guaranteePurchases: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default IneligiblePurchasesList;
